import React from 'react';
import { Icon, Modal } from 'antd';
import cn from 'classnames';
import { useModalVisible, useSetModalVisible } from '../../model/modelState';
import styles from './BaseModal.module.scss';

const BaseModal = ({
  onCancel,
  onOk,
  okText = 'OK',
  width = 650,
  disabled,
  loading,
  ...props
}) => {
  const visible = useModalVisible();
  const setVisible = useSetModalVisible();

  const handleCancel = () => {
    setVisible(false);

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };
  return (
    <Modal
      {...props}
      visible={visible}
      width={width}
      destroyOnClose
      onCancel={handleCancel}
      className={styles.customModal}
      footer={
        <div className={styles.footer}>
          {typeof onCancel === 'function' && (
            <div
              onClick={handleCancel}
              className={styles.cancelBtn}
            >
              Отменить
            </div>
          )}
          {typeof onOk === 'function' && (
            <div
              className={cn(styles.okBtn, { [styles.disabled]: disabled })}
              onClick={onOk}
            >
              {loading ? <Icon type="loading" /> : okText}
            </div>
          )}
        </div>
      }
    />
  );
};

export default BaseModal;
